import React from 'react';

export default () => <div className="aexp-lazyload-image--placeholder" />;
